import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChecklistComponent from "@Shared/components/checklist/checklist";
import { mapActions, mapState } from "vuex";
import { ADD_CHECKLIST, CREATE_CHECKLIST_TEMPLATE, LOAD_CHECKLIST_TEMPLATES, REMOVE_CHECKLIST_TEMPLATE } from "@Broker/@Modules/clients/board/store/board-actions";
import { showToast } from "../../../../../../../../shared/utils/constants";
import Err from "../../../../../../routes/error";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ChecklistTemplateEditor from "@Broker/@Modules/util-components/on-demand-checklist-templates/checklist-template-editor.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChecklistTab",
  components: {
    ChecklistComponent,
    SimpleButton,
    ChecklistTemplateEditor
  },
  props: {
    tabData: {
      type: Object,
      default: () => ({})
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    external: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "",
      checklist: [],
      loading: false,
      loadingSucceeded: false
    };
  },
  computed: _objectSpread({}, mapState("BoardStore", {
    templates(state) {
      var _state$checklistTempl;
      return ((_state$checklistTempl = state.checklistTemplates) == null ? void 0 : _state$checklistTempl.byId) || {};
    },
    isUniqueName(state) {
      var _state$checklistTempl2;
      const templates = ((_state$checklistTempl2 = state.checklistTemplates) == null ? void 0 : _state$checklistTempl2.byId) || {};
      return !_Object$values(templates).some(template => template.title === this.title);
    }
  })),
  async mounted() {
    this.loading = true;
    await this.LOAD_CHECKLIST_TEMPLATES();
    this.loadingSucceeded = true;
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [ADD_CHECKLIST, CREATE_CHECKLIST_TEMPLATE, LOAD_CHECKLIST_TEMPLATES, REMOVE_CHECKLIST_TEMPLATE])), {}, {
    async handleSubmit(isAddingTemplate) {
      this.loading = true;
      try {
        await this.ADD_CHECKLIST({
          id: this.clientProfileId,
          checklist: this.checklist,
          title: this.title
        });
        if (isAddingTemplate) {
          await this.CREATE_CHECKLIST_TEMPLATE({
            checklistData: {
              title: this.title,
              checklist: this.checklist
            }
          });
        }
        this.loadingSucceeded = true;
        this.$emit("submit");
        this.checklist = [];
        this.title = "";
        isAddingTemplate ? showToast("success", "checklistAndTemplateCreated") : showToast("success", "checklistCreated");
      } catch (e) {
        this.loadingSucceeded = false;
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    },
    handleUpdate({
      title,
      checklist
    }) {
      this.title = title;
      this.checklist = checklist;
    },
    handleTemplateSelect(selectedTemplate) {
      if (selectedTemplate) {
        this.title = selectedTemplate.title;
        this.checklist = selectedTemplate.checklist;
      }
    },
    async handleTemplateDelete(templateId) {
      this.loading = true;
      try {
        await this.REMOVE_CHECKLIST_TEMPLATE({
          templateId
        });
        showToast("success", this.$t("boards.messages.templateSuccesfullyDeleted"));
      } catch (e) {
        Err.handle(e);
        showToast("error", e);
      }
      this.loading = false;
    },
    handleSubmitClick() {
      if (!this.external) return;
      this.handleSubmit(false);
    },
    async handleAddTemplate(template) {
      this.loading = true;
      await this.CREATE_CHECKLIST_TEMPLATE({
        checklistData: template
      });
      this.loading = false;
      showToast("success", this.$t("boards.messages.templateSuccesfullyCreated"));
    },
    showTemplateEditor() {
      this.$refs.checklistTemplateEditor.show();
    }
  })
});